var _style, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrwizLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 168.05 168.05",
    style: {
      enableBackground: "new 0 0 168.05 168.05"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6442FB;}\n\t.st1{fill:#44F2E1;}\n\t.st2{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 84.03,
    cy: 84.03,
    r: 84.03
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.41,137.18c3.4,0,6.15-2.76,6.15-6.15c0-3.4-2.75-6.15-6.15-6.15c-3.4,0-6.15,2.75-6.15,6.15 C101.26,134.43,104.02,137.18,107.41,137.18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.75,49.34l6.29,41.49c0.29,1.72,1.72,2.86,3.43,2.86h51.35c3.15,0,5.86,2,6.87,4.86 c2.72,7.73,7.72,21.89,7.87,20.89c0-1.14,19.31-63.67,25.75-84.13c0.86-3-1.57-5.87-5.15-5.15L37.47,40.89c0.29,0,0,0-0.29,0 C33.46,41.9,31.03,45.47,31.75,49.34z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.63,124.02v-21.6h4.43v8.3h8.44v-8.3h4.43v21.6H63.5v-9.59h-8.44v9.59H50.63z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.24,102.99c0.86,0.29,1.43,0.86,2,1.57c0.43,0.57,0.86,1.14,1.14,1.86c0.29,0.72,0.43,1.43,0.43,2.29 c0,1-0.29,2-0.72,3c-0.57,1-1.43,1.72-2.57,2.15c1,0.43,1.72,1,2.15,1.72c0.43,0.72,0.57,1.86,0.57,3.43v1.43c0,1,0,1.72,0.14,2 c0.14,0.57,0.43,1,0.86,1.29v0.57h-5.01c-0.14-0.43-0.29-0.86-0.29-1.14c-0.14-0.57-0.14-1.29-0.14-1.86v-2 c0-1.43-0.29-2.29-0.72-2.72s-1.29-0.72-2.57-0.72h-4.43v8.44h-4.43v-21.89h10.3C84.38,102.42,85.53,102.56,86.24,102.99z  M76.95,106.14V112h4.86c1,0,1.72-0.14,2.15-0.29c0.86-0.43,1.29-1.29,1.29-2.43c0-1.29-0.43-2.15-1.29-2.58 c-0.43-0.29-1.14-0.43-2.15-0.43h-4.86V106.14z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.2,128.6l2.15,9.44l0.43,2.58l0.43-2.58l1.86-9.44h3.58l2,9.44l0.43,2.58l0.57-2.58l2.15-9.44h3.43 l-4.58,16.45h-3.29l-2-9.59l-0.57-3.15l-0.57,3.15l-1.86,9.44H54.2l-4.72-16.45h3.72V128.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.66,144.91h-3.43V128.6h3.43V144.91z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.66,142.05l8.44-10.59h-8.15v-2.86h12.3v2.72l-8.44,10.73h8.58v2.86H77.66V142.05z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrwizLogo);
export default __webpack_public_path__ + "static/media/hrwiz-logo.d42b71d6ee45ad494c49a25850c12f38.svg";
export { ForwardRef as ReactComponent };